var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import EdButton from "../../../../../../web/components/generic/edbutton/edButton";
import "@frameworks/salesjourney/stylesheets/components/Features/ClientDetails/ClientOverview/ClientFamilies.scss";
import createFamily from "@frameworks/shared-library/assets/images/SalesJourney/ClientDetails/createFamily.png";
import FamilyAccountTabs from "./FamilyAccountTabs";
import EdModal from "../../../../../../web/components/generic/edModal";
import AddNewFamilyFlow from "./AddNewFamilyFlow";
import clientDi from "../../di/serviceLocator";
import { useSelector } from "react-redux";
import Loader from "@frameworks/shared-library/components/Loader";
import { toCamelCase } from "@domains/utils/stringMethods";
export var ENewFamilyFlowComponent;
(function (ENewFamilyFlowComponent) {
    ENewFamilyFlowComponent["CREATEFAMILY"] = "CREATEFAMILY";
    ENewFamilyFlowComponent["ADDMEMBER"] = "ADDMEMBER";
    ENewFamilyFlowComponent["MEMBERDETAILS"] = "MEMBERDETAILS";
})(ENewFamilyFlowComponent || (ENewFamilyFlowComponent = {}));
export var EClientFamilyStatus;
(function (EClientFamilyStatus) {
    EClientFamilyStatus["CREATE_FAMILY_UI"] = "CREATE_FAMILY";
    EClientFamilyStatus["UCC_UNAVAILABLE"] = "UCC_UNAVAILABLE";
    EClientFamilyStatus["NO_ACCESS_VIEW"] = "NO_ACCESS_VIEW";
    EClientFamilyStatus["FAMILY_PRESENT"] = "FAMILY_PRESENT";
})(EClientFamilyStatus || (EClientFamilyStatus = {}));
export var EFamilyType;
(function (EFamilyType) {
    EFamilyType["SELF"] = "SELF";
    EFamilyType["OTHERS"] = "OTHERS";
})(EFamilyType || (EFamilyType = {}));
// created three different flows of components for 1.creating new families and adding members and 2.already existing families and adding members 3.other family.
var ClientFamilies = function () {
    var _a = __read(useState(false), 2), isFamilyPresent = _a[0], setIsFamilyPresent = _a[1];
    var _b = __read(useState(false), 2), showNewFamilyFlowPopup = _b[0], setShowNewFamilyFlowPopup = _b[1];
    var _c = __read(useState(false), 2), isLoader = _c[0], setIsLoader = _c[1];
    var _d = __read(useState(false), 2), popupLoader = _d[0], setPopupLoader = _d[1];
    var _e = __read(useState(ENewFamilyFlowComponent.CREATEFAMILY), 2), currentComponent = _e[0], setCurrentComponent = _e[1];
    var _f = __read(useState(), 2), familiesData = _f[0], setFamiliesData = _f[1];
    var _g = __read(useState(false), 2), isEditAccessForClientFamily = _g[0], setIsEditAccessForClientFamily = _g[1];
    var _h = __read(useState(EClientFamilyStatus.CREATE_FAMILY_UI), 2), viewToShow = _h[0], setViewToShow = _h[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getClientFamilyAccess = function () {
        setPopupLoader(true);
        setIsLoader(true);
        clientDi.clients
            .familyLinkingAccess({
            acCode: selectedAcount.accountCode,
            UccCode: selectedAcount.uniqueCode,
        })
            .then(function (resp) {
            setIsEditAccessForClientFamily(!!(resp === null || resp === void 0 ? void 0 : resp.clientFamilyEdit));
            checkForSelfFamilyData(!!(resp === null || resp === void 0 ? void 0 : resp.clientFamilyEdit));
        })
            .catch(function (err) {
            setIsLoader(false);
            setPopupLoader(false);
        });
    };
    var getFamilies = function (type, checkData) {
        if (type === void 0) { type = EFamilyType.SELF; }
        if (checkData === void 0) { checkData = false; }
        setIsLoader(true);
        setPopupLoader(true);
        clientDi.clients
            .getFamily({ type: type, UccCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.uniqueCode })
            .then(function (resp) {
            var _a;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setViewToShow(EClientFamilyStatus.FAMILY_PRESENT);
                // setIsFamilyPresent(true);
            }
            setIsLoader(false);
            setPopupLoader(false);
            setFamiliesData(resp === null || resp === void 0 ? void 0 : resp.data);
        })
            .catch(function (err) {
            setIsLoader(false);
            setPopupLoader(false);
        });
    };
    var getResendRequest = function (consentID, type) {
        setIsLoader(true);
        clientDi.clients
            .consentResend({ consentid: consentID })
            .then(function (resp) {
            var _a;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.status) === "Success") {
                getFamilies(type);
            }
            else {
                setIsLoader(false);
            }
        })
            .catch(function (err) {
            setIsLoader(false);
        });
    };
    var getCancelRequest = function (consentID, type) {
        setIsLoader(true);
        clientDi.clients
            .consentCancel({ consentid: consentID })
            .then(function (resp) {
            var _a;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.status) === "Success") {
                getFamilies(type);
            }
            else {
                setIsLoader(false);
            }
        })
            .catch(function (err) {
            setIsLoader(false);
        });
    };
    var createFamilyUi = function () {
        return (React.createElement("div", { className: "d-flex align-items-center justify-content-center pt-5" },
            React.createElement("div", { className: "d-flex align-items-center justify-content-center flex-column gap-4 create-family-block" },
                React.createElement("div", { className: "DMSanN_18_400 txt_primaryGrey text-center create-family-description" },
                    "Streamline your family investments",
                    React.createElement("br", null),
                    " with ",
                    React.createElement("span", { className: "DMSanBold_18_700" }, "Nuvama\u2019s"),
                    " ",
                    "Family Accounts"),
                React.createElement(EdButton, { value: "Create Family", btnTyp: "midnight-blue", onClick: function () {
                        setShowNewFamilyFlowPopup(true);
                        setCurrentComponent(ENewFamilyFlowComponent.CREATEFAMILY);
                    }, disabled: !isEditAccessForClientFamily }),
                React.createElement("img", { src: createFamily, alt: "Create Family" }))));
    };
    var uccNotAvailableView = function () {
        var _a;
        return (React.createElement("div", { className: "d-flex align-items-center justify-content-center pt-5" },
            React.createElement("div", { className: "no-permission-block d-flex align-items-center justify-content-center flex-column gap-3" },
                React.createElement("div", { className: "mb-3" },
                    React.createElement("i", { className: "edel-icon-no-group" })),
                React.createElement("span", { className: "DMSanBold_18_700 txt_primaryGrey" }, "Can\u2019t create family"),
                React.createElement("span", { className: "DMSanN_18_400 txt_primaryGrey text-center text-block" },
                    "Since ",
                    toCamelCase((_a = selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.clientName) === null || _a === void 0 ? void 0 : _a.split(" ")[0]),
                    " is not verified and has not generated a UCC, he cannot create a family. Create UCC to continue."))));
    };
    var noAccessView = function () {
        return (React.createElement("div", { className: "d-flex align-items-center justify-content-center pt-5" },
            React.createElement("div", { className: "no-permission-block d-flex align-items-center justify-content-center flex-column gap-3" },
                React.createElement("div", { className: "mb-3" },
                    React.createElement("i", { className: "edel-icon-eye-cross" })),
                React.createElement("span", { className: "DMSanBold_18_700 txt_primaryGrey" }, "You don\u2019t have permission to view"),
                React.createElement("span", { className: "DMSanN_18_400 txt_primaryGrey text-center text-block" }, "You will only have access to view your client\u2019s family details"))));
    };
    var checkForOtherFamilyData = function (isAccess) {
        clientDi.clients
            .getFamily({
            type: EFamilyType.OTHERS,
            UccCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.uniqueCode,
        })
            .then(function (resp) {
            var _a;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setViewToShow(EClientFamilyStatus.FAMILY_PRESENT);
                // setIsFamilyPresent(true);
            }
            else if (isAccess) {
                setViewToShow(EClientFamilyStatus.CREATE_FAMILY_UI);
            }
            else if (!isAccess) {
                setViewToShow(EClientFamilyStatus.NO_ACCESS_VIEW);
            }
            setIsLoader(false);
            setPopupLoader(false);
        })
            .catch(function (err) {
            setIsLoader(false);
            setPopupLoader(false);
        });
    };
    var checkForSelfFamilyData = function (isAccess) {
        clientDi.clients
            .getFamily({
            type: EFamilyType.SELF,
            UccCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.uniqueCode,
        })
            .then(function (resp) {
            var _a;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setViewToShow(EClientFamilyStatus.FAMILY_PRESENT);
                // setIsFamilyPresent(true);
                setIsLoader(false);
                setPopupLoader(false);
            }
            else {
                checkForOtherFamilyData(isAccess);
            }
        })
            .catch(function (err) {
            setIsLoader(false);
            setPopupLoader(false);
        });
    };
    useEffect(function () {
        if (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.uniqueCode) {
            getClientFamilyAccess();
        }
        else {
            setViewToShow(EClientFamilyStatus.UCC_UNAVAILABLE);
        }
    }, [selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.uniqueCode]);
    var generateViewComponent = function () {
        switch (viewToShow) {
            case EClientFamilyStatus.CREATE_FAMILY_UI:
                return createFamilyUi();
            case EClientFamilyStatus.FAMILY_PRESENT:
                return (React.createElement(FamilyAccountTabs, { setShowNewFamilyFlowPopup: setShowNewFamilyFlowPopup, setCurrentComponent: setCurrentComponent, familiesData: familiesData, getFamilies: getFamilies, popupLoader: popupLoader, setPopupLoader: setPopupLoader, selectedAcount: selectedAcount, getResendRequest: getResendRequest, getCancelRequest: getCancelRequest, isEditAccessForClientFamily: isEditAccessForClientFamily }));
            case EClientFamilyStatus.NO_ACCESS_VIEW:
                return noAccessView();
            case EClientFamilyStatus.UCC_UNAVAILABLE:
                return uccNotAvailableView();
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    return (React.createElement("div", { className: "client-families-container position-relative" },
        isLoader && React.createElement(Loader, { className: "client-families-loader" }),
        React.createElement("div", { className: "DMSan_24_700 txt_blackOne1 mb-4" }, "Manage Family Accounts"),
        generateViewComponent(),
        showNewFamilyFlowPopup && (React.createElement(EdModal, { title: "New Family", show: showNewFamilyFlowPopup, setShow: function (flag) {
                setShowNewFamilyFlowPopup(flag);
            }, size: "modal-dialog-centered", showFooter: false, modalTitle: "family-details-modal add-new-family-flow", stopClossOnOutsideClick: true, closeDropdown: function () { }, children: React.createElement(AddNewFamilyFlow, { setShowNewFamilyFlowPopup: setShowNewFamilyFlowPopup, setCurrentComponent: setCurrentComponent, currentComponent: currentComponent, selectedAcount: selectedAcount, popupLoader: popupLoader, setPopupLoader: setPopupLoader, getFamilies: getFamilies, familiesData: familiesData }) }))));
};
export default ClientFamilies;
